exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-star-rating {\n    display: inline-block !important;\n}\n", ""]);

// exports
